import { Injectable } from '@angular/core';

import { IWatermarkConfig } from '../interfaces/media.interfaces';

@Injectable({
  providedIn: 'root'
})
export class WatermarkService {
  private readonly baseUrl: string = 'https://justsext.com/creators';
  private readonly displayBaseUrl: string = 'JUSTSEXT.COM/CREATORS';
  private creatorName: string = '';

  generateWatermarkText(creatorName: string): string {
    const formattedName = creatorName.trim().replace(/\s+/g, '-').toUpperCase();
    this.creatorName = formattedName;
    return `${this.displayBaseUrl}/${formattedName}`;
  }

  navigateToCreator(): void {
    const fullUrl = `${this.baseUrl}/${this.creatorName.toLowerCase()}`;
    window.open(fullUrl, '_blank');
  }

  shouldShowWatermark(config: IWatermarkConfig): boolean {
    return config.showWatermark !== false && !!config.creatorName && !!config.creatorId;
  }
}
